import {DashboardUser} from '@/types/dashboardUser';
import api from '../index';

const dashboardUserUpdaters = {
  dashboardUser: async (dashboardUser: Partial<DashboardUser>) =>
    api.put(`/dashboard_user`, dashboardUser),
};

export default dashboardUserUpdaters;
